import { propClassName } from '@/styles/Factbox';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface FactboxImagesProps extends ComponentProps<'section'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
}

export const FactboxImagesComponent: Component<FactboxImagesProps> = ({
  children,
  className,
  variant,
  size,
  colors,
  ...props
}) => {
  const variantClassName = propClassName('images_variant', variant, 'default');
  const sizeClassName = propClassName('images_size', size, 'default');
  const colorsClassName = propClassName('images_colors', colors, 'primary');

  const componentClassName = cn(variantClassName, sizeClassName, colorsClassName, className);

  return (
    <section className={componentClassName} {...props}>
      {children}
    </section>
  );
};
